import { useCurrency } from '@shared/selectors/globalSelectors';
import React from 'react';

export default function SlabBased({ slabs = [], variant = 'bars' }: { slabs?: any[], variant?: 'bars' | 'table' }) {
  const currency = useCurrency();
  const safeSlabs = Array.isArray(slabs) ? slabs : [];

  if (variant === 'table') {
    return (
      <div className="rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full text-left text-xs">
          <thead className="bg-slate-50 font-semibold text-slate-500">
            <tr>
              <th className="px-4 py-3 tracking-wider">Range</th>
              <th className="px-4 py-3 tracking-wider">Type</th>
              <th className="px-4 py-3 text-right tracking-wider">Rate</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 bg-white">
            {safeSlabs.map((slab: any, index: number) => {
              const range = `${slab.from ?? 0}—${!slab.to || slab.to === 0 ? '∞' : slab.to}`;
              const typeLabel = slab.mode ? slab.mode.charAt(0).toUpperCase() + slab.mode.slice(1) : "N/A";
              
              return (
                <tr key={index}>
                  <td className="px-4 py-2.5 font-semibold text-slate-800">{range}</td>
                  <td className="px-4 py-2.5">
                    <span className="inline-flex justify-center rounded-full border border-cyan-200 bg-cyan-50 px-2.5 py-0.5 text-xs font-medium text-cyan-700">
                      {typeLabel}
                    </span>
                  </td>
                  <td className="px-4 py-2.5 text-right font-semibold text-slate-800">
                    {currency} {slab.rate ?? 0} <span className="font-normal text-slate-400 ml-1">{slab.unit || "N/A"}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  const maxRate = Math.max(...safeSlabs.map((s: any) => s.rate || 0), 1);
  return (
    <div className="space-y-3">
      {safeSlabs.map((slab: any, index: number) => {
        const range = `${slab.from ?? slab.startTime ?? 0}—${slab.to ?? slab.endTime ?? 0}`;
        const barWidth = `${((slab.rate || 0) / maxRate) * 100}%`;
        const typeLabel = slab.mode ? slab.mode.charAt(0).toUpperCase() + slab.mode.slice(1) : "N/A";
        
        return (
          <div key={index} className="flex items-center gap-4">
            <div className="w-16 shrink-0 text-xs font-medium text-slate-600">
              {range}
            </div>
            <div className="shrink-0 w-20">
              <span className="inline-flex w-full justify-center rounded-full border border-cyan-200 bg-cyan-50 px-2 py-0.5 text-xs font-medium text-cyan-700">
                {typeLabel}
              </span>
            </div>
            <div className="relative h-8 flex-1 overflow-hidden rounded-md bg-slate-50">
              <div 
                className="absolute inset-y-0 left-0 flex items-center rounded-md bg-[#1d64c9] px-3 text-xs font-semibold text-white transition-all duration-500"
                style={{ width: barWidth, minWidth: 'fit-content' }}
              >
                {currency} {slab.rate ?? 0} {slab.unit || "N/A"}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
